import { useTranslation } from "react-i18next";

import {
  ApplicationButton,
  ApplicationSectionHeader,
  ApplicationSurface,
} from "../../../components/application";
import {
  getEntryShortDescription,
  getEntryTitle,
} from "../../../catalog/utils/catalogDisplay";

export default function FacilitatedActivitySummaryCard({
  entry,
  onStart,
}) {
  const { t } = useTranslation();

  if (!entry) {
    return null;
  }

  const title = getEntryTitle(entry, t);
  const description =
    getEntryShortDescription(entry, t);

  return (
    <ApplicationSurface
      className="av-facilitated-activity-card"
      variant="section"
    >
      <ApplicationSectionHeader
        headingLevel={2}
        title={title}
        variant="compact"
      />

      {description && <p>{description}</p>}

      <ApplicationButton onClick={() => onStart?.(entry)}>
        Start live session
      </ApplicationButton>
    </ApplicationSurface>
  );
}
